<template>
  <v-dialog v-model="value" max-width="900" @keydown.esc="dismiss()" persistent scrollable>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center blue white--text py-2">
        <div>
          {{ $t('payment.water_and_electricity_last') }}
        </div>
        <v-btn color="white" icon @click="dismiss()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-0 py-0" v-show="!isLoading">
        <v-container>
          <div class="ps-4" v-if="getMetersWater && getMetersWater.length > 0">
            <div class="ps-3 d-flex justify-end">
              <v-btn v-if="isDigitalMeter" @click="getDigitalMeterUnit()" class="mx-1"
                :disabled="isLoading || isLoadingDigitalMeter" outlined color="grey darken-3">
                <v-icon class="me-2">mdi-cloud-download</v-icon>{{ $t('meter.read_data_digital_meter') }}
              </v-btn>
            </div>
           
            <v-card-title>
              <h2>{{ $t('meter.water_meter') }}</h2>
            </v-card-title>
            <template v-for="meter in getMetersWater">
              <v-card :key="`water_${meter.objectId}`" class="my-2">
                <v-card-title>
                  <h4>
                    {{ meter.area.name }} (
                    <template v-if="meter.name">{{ meter.name }}</template>
                    <template v-else-if="meter.isMain">{{ $t('main') }}</template>
                    <template v-else>{{ $t('additional') }}</template>
                    )
                  </h4>
                </v-card-title>
                <v-container v-if="hashMetersUnit[meter.objectId]">
                  <v-row>
                    <v-col cols="4">
                      <label>{{ $t('meter.previous_unit') }}</label>
                      <v-text-field solo hide-details="auto" class="input-center input-disable-appearance" type="text"
                        style="opacity: 0.75" v-model="hashMetersUnit[meter.objectId].previousUnit"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="text-center">
                      <label>{{ $t('meter.last_unit') }}</label>
                      <v-text-field background-color="rgb(211,237,244)" solo hide-details="auto"
                        class="input-center input-disable-appearance" type="text" style="opacity: 0.75"
                        v-model="hashMetersUnit[meter.objectId].unit"></v-text-field>
                      <small v-if="meter.digitalMeterData && hashMetersUnit[meter.objectId].dateTime"
                        :class="hashMetersUnit[meter.objectId].isOffline ? 'red--text' : ''">{{ $t('updatedate') }}
                        {{ $moment(hashMetersUnit[meter.objectId].dateTime).format('lll') }}</small>
                    </v-col>
                    <v-col :cols="isDigitalMeter ? '3' : '4'">
                      <label>{{ $t('meter.unit') }}</label>
                      <div class="d-flex justify-center pt-3 pb-3"
                        :class="hashMetersUnit[meter.objectId].unit - (hashMetersUnit[meter.objectId].previousUnit || 0) < 0 ? 'unit-error' : ''">
                        {{ parseFloat(hashMetersUnit[meter.objectId].unit) - (hashMetersUnit[meter.objectId].previousUnit
                          || 0) | arabic }}</div>
                    </v-col>
                    <v-col v-if="isDigitalMeter" cols="1" class="text-center pt-10">
                      <v-btn v-if="isMeterDateDialogCanRead(meter)" :disabled="isLoadingDigitalMeter" icon
                        @click="getDigitalMeterUnit(meter)">
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </template>
            <h3 class="text-gray-300 text-center" v-if="!getMetersWater || getMetersWater.length == 0">
              {{ $t('meter.no_water_meter_setting') }}</h3>
          </div>
          <div class="ps-4 mt-8" v-if="getMetersElec && getMetersElec.length > 0">
            <v-card-title>
              <h2>{{ $t('meter.electricity_meter') }}</h2>
            </v-card-title>
            <template v-for="meter in getMetersElec">
              <v-card :key="`elec_${meter.objectId}`" class="my-2">
                <v-card-title>
                  <h4>
                    {{ meter.area.name }} (
                    <template v-if="meter.name">{{ meter.name }}</template>
                    <template v-else-if="meter.isMain">{{ $t('main') }}</template>
                    <template v-else>{{ $t('additional') }}</template>
                    )
                  </h4>
                </v-card-title>
                <v-container v-if="hashMetersUnit[meter.objectId]">
                  <v-row>
                    <v-col cols="4">
                      <label>{{ $t('meter.previous_unit') }}</label>
                      <v-text-field solo hide-details="auto" class="input-center input-disable-appearance" type="text"
                        style="opacity: 0.75" v-model="hashMetersUnit[meter.objectId].previousUnit"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="text-center">
                      <label>{{ $t('meter.last_unit') }}</label>
                      <v-text-field background-color="rgb(255, 0, 0, 0.3)" solo hide-details="auto"
                        class="input-center input-disable-appearance" type="text" style="opacity: 0.75"
                        v-model="hashMetersUnit[meter.objectId].unit"></v-text-field>
                      <small v-if="meter.digitalMeterData && hashMetersUnit[meter.objectId].dateTime"
                        :class="hashMetersUnit[meter.objectId].isOffline ? 'red--text' : ''">{{ $t('updatedate') }}
                        {{ $moment(hashMetersUnit[meter.objectId].dateTime).format('lll') }}</small>
                    </v-col>
                    <v-col :cols="isDigitalMeter ? '3' : '4'">
                      <label>{{ $t('meter.unit') }}</label>
                      <div class="d-flex justify-center pt-3 pb-3"
                        :class="hashMetersUnit[meter.objectId].unit - (hashMetersUnit[meter.objectId].previousUnit || 0) < 0 ? 'unit-error' : ''">
                        {{ parseFloat(hashMetersUnit[meter.objectId].unit) - (hashMetersUnit[meter.objectId].previousUnit
                          || 0) | arabic }}</div>
                    </v-col>
                    <v-col v-if="isDigitalMeter" cols="1" class="text-center pt-10">
                      <v-btn v-if="isMeterDateDialogCanRead(meter)" :disabled="isLoadingDigitalMeter" icon
                        @click="getDigitalMeterUnit(meter)">
                        <v-icon>mdi-cloud-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </template>
            <h3 class="text-gray-300 text-center" v-if="!getMetersElec || getMetersElec.length == 0">
              {{ $t('meter.no_electricity_meter_setting') }}</h3>
          </div>
        </v-container>
      </v-card-text>

      <v-card-text class="px-0 py-0">
        <v-card class="justify-center py-10 d-flex" v-if="isLoading" elevation="0">
          <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
        </v-card>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" @click="dismiss()">{{ $t('close') }}</v-btn>
        <v-btn color="info" :disabled="isLoading" @click="submitData()">
          <v-icon dark class="me-2">mdi-calculator-variant</v-icon>{{ $t('payment.calculate_water_and_electricity') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <DigitalMeterDateDialog v-model="isMeterDateDialog" :isMainLoading="isLoading || isLoadingDigitalMeter"
      :digitalMeterDataList="tempDigitalMeterDataList" @onSuccess="onDigitalMeterDate" />
    <v-snackbar v-model="isReadSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('readsuccess') }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { MeterRecord, Invoice, DigitalMeter, DigitalWaterMeter } from "../classes";
import DigitalMeterDateDialog from "@/components/DigitalMeterDateDialog.vue";
export default {
  props: {
    value: Boolean,
    areaIds: Array
  },
  components: {
    DigitalMeterDateDialog
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      isLoading: false,
      isError: false,
      hashMetersUnit: {},
      hashMeterRecord: {},
      isDigitalMeter: false,
      hashDigitalMetersUnit: null,
      isLoadingDigitalMeter: false,
      isReadSuccess: false,
      project: null,
      tempMeter: null,
      isMeterDateDialog: false,
      digitalMeterDataList: null,
      tempDigitalMeterDataList: null
    };
  },
  watch: {
    value(newv) {
      if (newv) this.initData();
    }
  },
  computed: {
    ...mapGetters({
      getMetersWater: "meter/getMetersWater",
      getMetersElec: "meter/getMetersElec"
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
  },
  created() {
    if (this.admins && this.admins.length) {
      this.project = this.admins[0].project;
    } else if (this.employees && this.employees.length) {
      this.project = this.employees[0].project;
    }
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.hashMetersUnit = {};
      this.digitalMeterDataList = [];
      try {
        await this.$store.dispatch("meter/getMeterByAreas", {
          areaIds: this.areaIds
        });
        let meterRecords = await MeterRecord.getLastMeterRecordsByMeters(
          [...this.getMetersWater, ...this.getMetersElec].map(d => d.objectId)
        );
        for (let meterRecord of meterRecords) {
          this.hashMeterRecord[meterRecord.meter.objectId] = meterRecord;
        }
        let tempHashMetersUnit = {};
        for (let meter of [...this.getMetersWater, ...this.getMetersElec]) {
          if (meter.digitalMeterData && meter.digitalMeterData.type != "prepaid") {
            this.digitalMeterDataList.push(meter.digitalMeterData);
            this.isDigitalMeter = true;
          }
          if (!tempHashMetersUnit[meter.objectId]) tempHashMetersUnit[meter.objectId] = {};
          tempHashMetersUnit[meter.objectId].meter = meter;
          tempHashMetersUnit[meter.objectId].unit = 0;
          tempHashMetersUnit[meter.objectId].previousUnit = 0;

          if (this.hashMeterRecord[meter.objectId]) {
            tempHashMetersUnit[
              meter.objectId
            ].previousUnit = this.hashMeterRecord[meter.objectId].unit;
          }
        }
        this.hashMetersUnit = tempHashMetersUnit;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async submitData() {
      this.isLoading = true;
      try {
        let postData = [];
        for (const [key, value] of Object.entries(this.hashMetersUnit)) {
          if (parseFloat(value.unit) - parseFloat(value.previousUnit) > 0) {
            let obj = {
              meterId: value.meter.objectId,
              previousUnit: parseFloat(value.previousUnit),
              unit: parseFloat(value.unit)
            };
            postData.push(obj);
          }
        }
        let items = [];
        items = await Invoice.generateInvoiceItems(postData);
        if (!items || items.length == 0) {
          this.$toast.show({
            content: this.$t('validate.water_and_electricity_is_zero_or_not_set'),
            color: "warning"
          });
        }
        this.isLoading = false;
        this.$emit("onSuccess", items);
        this.dismiss();
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.isError = true;
      }
    },
    getDigitalMeterUnit(meter){
      this.tempMeter = null
      if(meter) {
        this.tempMeter = meter
        this.tempDigitalMeterDataList = [meter.digitalMeterData]
      } else {
        this.tempDigitalMeterDataList = this.digitalMeterDataList
      }
      this.isMeterDateDialog = true
    },
    onDigitalMeterDate(dateTime){
      if (this.tempMeter){
        this.loadDigitalMeterUnit(this.tempMeter, dateTime)
      } else {
        this.loadAllDigitalMeterUnit(dateTime)
      }
    },
    async loadDigitalMeterUnit(meter, dateTime) {
      this.isLoadingDigitalMeter = true;
      this.hashDigitalMetersUnit = {}
      try {
        let { partner, type, cust_id, meter_id } = meter.digitalMeterData
        if (meter.type == "elec") {
          this.hashDigitalMetersUnit = await DigitalMeter.getLatestMeterData(
            partner,
            type,
            cust_id,
            meter_id,
            dateTime
          )
        } else if (meter.type == "water") {
          this.hashDigitalMetersUnit = await DigitalWaterMeter.getLatestMeterData(
            partner,
            type,
            cust_id,
            meter_id,
            dateTime
          )
        }
        if (this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`]) {
          let data = this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`];
          this.hashMetersUnit[meter.objectId].unit = data.unit || 0;
          this.hashMetersUnit[meter.objectId].dateTime = data.datetime;
          this.hashMetersUnit[meter.objectId].isOffline = data.isOffline
        }

        this.isReadSuccess = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      } catch (err) {
        this.isError = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      }
    },
    async loadAllDigitalMeterUnit(dateTime) {
      this.isLoadingDigitalMeter = true;
      try {
        if (this.isDigitalMeter) {
          let listElec = []
          let listWater = []
          for (let meter of this.getMetersElec) {
            if (meter.digitalMeterData) {
              let { partner, type, cust_id } = meter.digitalMeterData
              if (partner == 'xten') {
                listElec.push({...meter.digitalMeterData, dateTime})
              } else {
                if (!listElec.find(d => d.cust_id == cust_id && d.type == type)) listElec.push({partner, cust_id, type, dateTime})
              }
            }
          }
          for (let meter of this.getMetersWater) {
            if (meter.digitalMeterData) {
              let { partner, type, cust_id } = meter.digitalMeterData
              if (partner == 'xten') {
                listWater.push({...meter.digitalMeterData, dateTime})
              } else {
                if (!listWater.find(d => d.cust_id == cust_id && d.type == type)) listWater.push({partner, cust_id, type, dateTime})
              }
            }
          }

          let promises = []
          for (let data of listElec) {
            promises.push(DigitalMeter.getLatestMeterData(data.partner, data.type, data.cust_id, data.meter_id, data.dateTime))
          }
          for (let data of listWater) {
            promises.push(DigitalWaterMeter.getLatestMeterData(data.partner, data.type, data.cust_id, data.meter_id, data.dateTime))
          }

          let results = await Promise.all(promises)
          for (let data of results) {
            this.hashDigitalMetersUnit = {
              ...this.hashDigitalMetersUnit,
              ...data
            }
          }
        }

        for (let meter of [...this.getMetersWater, ...this.getMetersElec]) {
          if (meter.digitalMeterData) {
            let cust_id = meter.digitalMeterData.cust_id;
            let meter_id = meter.digitalMeterData.meter_id;

            if (
              this.hashMetersUnit[meter.objectId] &&
              this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`]
            ) {
              let data = this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`];
              this.hashMetersUnit[meter.objectId].unit = data.unit || 0;
              this.hashMetersUnit[meter.objectId].dateTime = data.datetime;
              this.hashMetersUnit[meter.objectId].isOffline = data.isOffline
            }
          }
        }

        this.isReadSuccess = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      } catch (err) {
        this.isError = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false
      }
    },
    isMeterDateDialogCanRead(meter) {
      if (meter && meter.digitalMeterData && meter.digitalMeterData.meter_type != "prepaid") {
        return true
      }
    },
    dismiss() {
      this.$emit("input", false);
    }
  }
};
</script>

<style>
.unit-error {
  background-color: rgba(255, 0, 0, 0.5);
  color: white;
}
</style>